module.exports = __webpack_public_path__ + "static/media/schedule.7caa9c1f.svg";